(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eg-shipping-calculator"] && !Shopify.designMode) return;
  try {
    
   (function () { 
    class EgShippingCalculator extends HTMLElement {
      constructor () {
        super()

        this.country = this.querySelector('#eg-shipping-calculator-country')
        this.province = this.querySelector('#eg-shipping-calculator-province')
        this.zip = this.querySelector('#eg-shipping-calculator-zip')
        this.alert = this.querySelector('#eg-shipping-calculator-alert')
        this.btn = this.querySelector('button')

        this.initCommonJsScript()
        this.insertInCartDrawer()
        this.listenCartDrawer()
        this.insertInCartPage()

        this.btn.addEventListener('click', this.onSubmit.bind(this))
      }

      async initCommonJsScript () {
        const script = document.createElement('script')
        script.src = this.dataset.shopifyCommonJs
        document.head.appendChild(script)

        await new Promise(resolve => setTimeout(resolve, 1000))

        new window.Shopify.CountryProvinceSelector('eg-shipping-calculator-country', 'eg-shipping-calculator-province', {
          hideElement: 'eg-shipping-calculator-province-wrapper'
        })

        this.country.options[0].textContent = this.country.getAttribute('aria-label')
      }

      insertInCartDrawer() {
        const drawer = document.querySelector('#CartDrawer')
        if (!drawer) return

        if (drawer.querySelector('#eg-shipping-calculator')) return

        const wrapper = document.querySelector('#eg-shipping-calculator-cart-drawer-wrapper')
        if (!wrapper) return

        drawer.querySelector('.drawer__footer').insertAdjacentHTML('afterbegin', wrapper.innerHTML)
      }

      listenCartDrawer() {
        const drawer = document.querySelector('#CartDrawer')
        if (!drawer) return
    
        let timer
        
        const observer = new MutationObserver((mutations) => { 
          if (timer) clearTimeout(timer)

          timer = setTimeout(async () => {
            const respoonse = await fetch(window.location.href)
            const text = await respoonse.text()
            const newDocument = new DOMParser().parseFromString(text, 'text/html')
            
           this.insertInCartDrawer()
          }, 250)
        })

        observer.observe(drawer, {  
          attributes: true, 
          childList: true, 
          subtree: true
        });
      }

      insertInCartPage() {
        const cartFooter = document.querySelector('#main-cart-footer')
        if (!cartFooter) return

        if (document.querySelector('#MainContent #eg-shipping-calculator')) return

        const wrapper = document.querySelector('#eg-shipping-calculator-cart-page-wrapper')
        if (!wrapper) return

        cartFooter.querySelector('.cart__blocks').insertAdjacentHTML('afterbegin', wrapper.innerHTML)
      }

      async onSubmit () {
        this.btn.classList.add('loading')
        this.btn.querySelector('.loading__spinner').classList.remove('hidden')

        const prepareResponse = await fetch(`/cart/prepare_shipping_rates.json?shipping_address[zip]=${this.zip.value}&shipping_address[country]=${this.country.value}&shipping_address[province]=${this.province.value}`, {
          method: 'POST'
        })
        console.log(prepareResponse)

        if (prepareResponse.ok) {
          const asyncResponse = await fetch(`/cart/async_shipping_rates.json?shipping_address[zip]=${this.zip.value}&shipping_address[country]=${this.country.value}&shipping_address[province]=${this.province.value}`)
          console.log(asyncResponse)

          const data = await asyncResponse.json()
          console.log(data)

          let list = ''

          if (data.shipping_rates.length) {
            data.shipping_rates.forEach(elem => {
              list += `
                <li>
                  <strong>${elem.presentment_name}</strong>: ${elem.price} ${elem.currency}
                </li>
              `
            })

            this.alert.innerHTML = `
              <ul class="">
                ${list}
              </ul>
            `
            this.alert.classList.remove('alert-danger', 'alert-warning')
            this.alert.classList.add('alert-success')
            this.alert.removeAttribute('hidden')
          } else {
            this.alert.innerHTML = `
              <p class="">
                ${this.dataset.textNoResultsFound}
              </p>
            `
            this.alert.classList.remove('alert-danger', 'alert-success')
            this.alert.classList.add('alert-warning')
            this.alert.removeAttribute('hidden')
          }
        } else {
          const data = await prepareResponse.json()
          console.log(data)

          let list = ''

          for (const [key, value] of Object.entries(data)) {
            list += `
              <li>
                <b>${key}</b>: ${value.toString()}
              </li>
            `
          }

          this.alert.innerHTML = `
            <ul class="">
              ${list} 
            </ul>
          `
          this.alert.classList.remove('alert-success', 'alert-warning')
          this.alert.classList.add('alert-danger')
          this.alert.removeAttribute('hidden')
        }

        this.btn.classList.remove('loading')
        this.btn.querySelector('.loading__spinner').classList.add('hidden')
      }
    }
    customElements.define('eg-shipping-calculator', EgShippingCalculator) 
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
